// Generated by rollup-plugin-mjs-entry

import cjs from './index.js';

export const ERRORS_CHANNEL = cjs.ERRORS_CHANNEL;
export const ReplayEmitter = cjs.ReplayEmitter;
export const UUID = cjs.UUID;
export const expiresInDays = cjs.expiresInDays;
export const expiresInHours = cjs.expiresInHours;
export const isArray = cjs.isArray;
export const isFunction = cjs.isFunction;
export const isNonEmpty = cjs.isNonEmpty;
export const isObject = cjs.isObject;
export const isRecord = cjs.isRecord;
export const isString = cjs.isString;
export const isUUID = cjs.isUUID;
export const nonNull = cjs.nonNull;
export const safeToString = cjs.safeToString;
export const strEqualsIgnoreCase = cjs.strEqualsIgnoreCase;
export const trim = cjs.trim;
export const wrapError = cjs.wrapError;
